module.exports = __webpack_public_path__ + "static/WuFan-Anchor.ef5dfedf.png";